export default __webpack_public_path__ + "static/media/vendors-profile-001.aabad896.png";